// extracted by mini-css-extract-plugin
module.exports = {"svg":"JS7CE","svg--dark":"i34Up"};